import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { reportScriptLoadingError } from '../domain/scriptLoadingError';
export function lazyLoadProfiler() {
  return _lazyLoadProfiler.apply(this, arguments);
}

function _lazyLoadProfiler() {
  _lazyLoadProfiler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var importProfilerImpl,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            importProfilerImpl = _args.length > 0 && _args[0] !== undefined ? _args[0] : importProfiler;
            _context.prev = 1;
            _context.next = 4;
            return importProfilerImpl();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            reportScriptLoadingError({
              error: _context.t0,
              source: 'Profiler',
              scriptType: 'module'
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));
  return _lazyLoadProfiler.apply(this, arguments);
}

function importProfiler() {
  return _importProfiler.apply(this, arguments);
}

function _importProfiler() {
  _importProfiler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var module;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import(
            /* webpackChunkName: "profiler" */
            '../domain/profiling/profiler');

          case 2:
            module = _context2.sent;
            return _context2.abrupt("return", module.createRumProfiler);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _importProfiler.apply(this, arguments);
}